import type {
  ExpandedSpotQuoteContact,
  SpotQuoteGroupWithUsers,
  UpsertSpotQuoteContactDto,
} from '@fv/models'
import type { DTO } from '@fv/models/core'

export type SpotQuoteContact = DTO<ExpandedSpotQuoteContact>
export type SpotQuoteGroup = DTO<SpotQuoteGroupWithUsers>
export type { UpsertSpotQuoteContactDto }

export const spotContactKeys = {
  all: ['spot-quote-groups'],
}
